import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const Footer = styled.div`
  color: ${ThemePrisma.colors.gray[5]};
  font-weight: bold;
  text-align: center;
  border-left: 1px solid #004877;
  background: #e6edf2;
  padding-left: ${ThemePrisma.spacing['2xlarge']};
  padding-right: ${ThemePrisma.spacing['2xlarge']};

  @media (min-width: 1365px) {
    padding-left: ${ThemePrisma.spacing['3xlarge']};
    padding-right: ${ThemePrisma.spacing['3xlarge']};
  }

  .footer-container {
    border-top: 1px solid ${ThemePrisma.colors.gray[4]};
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
`;
